import { Subject } from "@pjs/observables";
import { IMultiStepDialogInstance } from "../dialog-instance/interfaces/IMultiStepDialogInstance";

export const dialogViewSubject = new Subject<IMultiStepDialogInstance<any>>();
